import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DatePicker from "react-datepicker";

const EditBlogForm = (props) => {
  const {
    loadingCallback,
    navigate,
    setShowPaymentModal,
    setShowModal,
    isOpen,
    title,
    type,
    refetch,
    coupon,
    notify,
    getCouponList,
  } = props;

  const token = localStorage.getItem("token");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    coupon_name: coupon.coupon_name || "",
    coupon_code: coupon.coupon_code || "",
    amount: coupon.amount || "",
    usage_limit: coupon.usage_limit || "",
    expire_date: coupon.expire_date || "",
    description: coupon.description || "",
  });

  useEffect(() => {
    if (coupon) {
      setFormData({
        coupon_name: coupon.coupon_name || "",
        coupon_code: coupon.coupon_code || "",
        amount: coupon.amount || "",
        usage_limit: coupon.usage_limit || "",
        expire_date: coupon.expire_date || "",
        description: coupon.description || "",
      });
    }
  }, [coupon]);


  const handleUpdate = async () => {

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}update-coupon/${coupon.id}`,
        formData,
        {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      notify(response.data.message, "success");
      getCouponList();
      setShowModal(false);
    } catch (error) {
      notify("Failed to update coupon.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="duration-500 w-[3/4] h-[3/4]">
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Coupon Name
        </label>
        <input
          type="text"
          name="coupon_name"
          placeholder="Coupon Name"
          value={formData.coupon_name}
          onChange={(e) =>
            setFormData({
              ...formData,
              coupon_name: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Coupon Code
        </label>
        <input
          type="text"
          name="coupon_code"
          placeholder="Coupon Code"
          value={formData.coupon_code}
          onChange={(e) =>
            setFormData({
              ...formData,
              coupon_code: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Amount
        </label>
        <input
          type="number"
          name="amount"
          placeholder="Amount"
          value={formData.amount}
          onChange={(e) =>
            setFormData({
              ...formData,
              amount: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Usage limit
        </label>
        <input
          type="number"
          name="usage_limit"
          placeholder="Usage limit"
          value={formData.usage_limit}
          onChange={(e) =>
            setFormData({
              ...formData,
              usage_limit: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] font-semibold bg-white px-1 -top-2 left-3 z-10">
          Expire Date
        </label>
        <DatePicker
          selected={formData.expire_date}
          onChange={(date) =>
            setFormData({
              ...formData,
              expire_date: date,
            })
          }
          dateFormat="yyyy-MM-dd"
          placeholderText="Select expire date"
          className=" w-full border border-gray-300 rounded px-3 py-[10px] text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>
      <div className="flex flex-col mt-2">
        <div className="w-full relative mt-2">
            <label className="absolute font-nunito text-xs text-[#102048] left-[12px] top-[-7px] bg-white px-1 font-semibold">
              Description
            </label>
            <div className="mt-4">
              <ReactQuill
                value={formData.description || ""}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    description: value,
                  })
                }
                className="bg-white"
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link", "image"],
                    ["clean"],
                  ],
                }}
                formats={[
                  "header",
                  "bold",
                  "italic",
                  "underline",
                  "strike",
                  "list",
                  "bullet",
                  "link",
                  "image",
                ]}
              />
            </div>
          </div>

          <div>
            <button
              onClick={handleUpdate}
              disabled={isSubmitting}
              className={`cursor-pointer w-full mt-4 ${
                isSubmitting ? "bg-gray-400" : "bg-[#3559b3] hover:bg-[#034AFF]"
              } py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg`}
            >
              {isSubmitting ? "Updating..." : "Done"}
            </button>
          </div>
      </div>
    </div>
  );
};

export default EditBlogForm;
